import {
  GET_COUPON_PARTNER,
  GET_COUPON_PARTNER_SUCCESS,
  GET_COUPON_PARTNER_ERROR,
} from './../../actionType.js'

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
}

const GetCouponPartner = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUPON_PARTNER:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      }
      break

    case GET_COUPON_PARTNER_SUCCESS:
      state = {
        ...state,
        data: action.payload.results,
        loading: false,
        success: true,
        error: false,
        message: null,
      }
      break

    case GET_COUPON_PARTNER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default GetCouponPartner
